import comp from "./WarningTooltip";
export default comp;
